export default __webpack_public_path__ + "static/media/hair_dryer.d8eeaf47.svg";